import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { nativeReturnLink } from "@/lib/native-auth";

export const Route = createFileRoute("/app_/native-return")({
  head: () => ({
    meta: [
      { title: "Returning to the app · XAU Pro Academy" },
      { name: "description", content: "Completing sign-in and returning to the XAU Pro Academy app." },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Returning to the app · XAU Pro Academy" },
      { property: "og:description", content: "Completing sign-in and returning to the XAU Pro Academy app." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: NativeReturn,
});

function NativeReturn() {
  const [link, setLink] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let done = false;
    const go = (s: { access_token: string; refresh_token: string } | null) => {
      if (done || !s) return;
      done = true;
      const l = nativeReturnLink(s.access_token, s.refresh_token);
      setLink(l);
      window.location.href = l;
    };
    supabase.auth.getSession().then(({ data }) => go(data.session));
    const { data: sub } = supabase.auth.onAuthStateChange((_e, s) => go(s));
    const t = window.setTimeout(() => { if (!done) setFailed(true); }, 10000);
    return () => { sub.subscription.unsubscribe(); window.clearTimeout(t); };
  }, []);

  return (
    <main className="grid min-h-screen place-items-center bg-background px-6 text-center">
      <div className="max-w-xs space-y-4">
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-gold">XAU Pro Academy</p>
        <h1 className="text-lg font-semibold text-foreground">
          {failed ? "Sign-in not completed" : "Returning to the app"}
        </h1>
        <p className="text-sm text-muted-foreground">
          {failed ? "Open the app and try signing in again." : "You are signed in. The app will open now."}
        </p>
        {link && (
          <a href={link} className="inline-block rounded-full border border-gold/40 px-5 py-2 text-sm font-semibold text-gold">
            Open the app
          </a>
        )}
      </div>
    </main>
  );
}
